// Carousel module API
import initCarousels from "Modules/Carousel/CarouselManager";

// API
export default {
  initialiseCarousels: initCarousels
};